import { Config } from '../../config';
import React from 'react';
import './style.scss';

const ErrorPage = () => <section className="error_page"><h1>{ Config.message.error.notFound }</h1></section>

export default ErrorPage